import http from 'common/http'

export function fetchPartners(page = 1, pageSize = 10, search = '') {
  return http.get('/partner/list', {
    params: {
      page,
      pageSize,
      search: search || undefined,
    },
  })
}

export function editPartner(id: string, data: any) {
  return http.put(`/partner/${id}`, data)
}

export function fetchPartnerOrganizations() {
  return http.get('/partner/organizations', {})
}

export function changeTenantSubscription(
  customerId: string,
  status: string,
  subscriptionPeriodId: number,
) {
  return http.post('/partner/subscription', {
    customerId,
    status,
    subscriptionPeriodId,
  })
}

export function createNextSubscriptionPeriod(customerId: string) {
  return http.post('/partner/subscription/period', {
    customerId,
  })
}
